/**
 * @fileoverview The ONE vocabulary of `inventory_transactions.transactionType` — every movement type the stock
 * ledger records (L-R7CLOSE row 54; moved here by SEAM-001 F9).
 *
 * ## Why it lives here
 *
 * It is exactly the set the table's `inventory_transactions_type_check` constraint admits, so a value outside it is
 * refused by the database on write and can match no row on read. It lived in `@puffin-core/inventory`, an API-only
 * package no browser can import, so a web surface that offered or named a movement type had to copy the list. It
 * moved here UNCHANGED (the same ten values, the same order) and `@puffin-core/inventory` no longer exports it:
 *
 * - pos-api's `GET /v1/inventory/:productId/history?transactionType=` validates against THIS array;
 * - `@puffin-core/inventory`'s `InventoryTransaction.getTransactionTypes()` returns it;
 * - pos-web's movement-history screen offers it as its filter, and the movement report words each value.
 *
 * @module @puffin-core/status-taxonomy/inventoryMovementType
 */

'use strict';

/**
 * Every movement type the ledger records, in the order the ledger declares them.
 *
 * @type {ReadonlyArray<string>}
 */
const INVENTORY_MOVEMENT_TYPES = Object.freeze([
  'sale',
  'purchase',
  'adjustment',
  'transfer_in',
  'transfer_out',
  'return',
  'damage',
  'shrinkage',
  'receiving',
  'initial',
]);

module.exports = { INVENTORY_MOVEMENT_TYPES };
